import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

import { composerPanelBorderSx } from "./composerBorderStyles";

/** Matches TitleStep / ContentStep / EventSettingsStep section headings. */
export const composerSectionHeadingSx = {
  fontWeight: 400,
  color: "primary.main",
  fontSize: { xs: "1.125rem", sm: "1.25rem" },
} as const;

export type ComposerStepCardProps = {
  title: string;
  subtitle?: string;
  optional?: boolean;
  children: React.ReactNode;
};

const ComposerStepCard: React.FC<ComposerStepCardProps> = ({
  title,
  subtitle,
  optional,
  children,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        p: { xs: 1.5, sm: 2 },
        ...composerPanelBorderSx,
      }}
    >
      <Box sx={{ mb: subtitle ? 1.25 : 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Typography variant="h6" sx={composerSectionHeadingSx}>
            {title}
          </Typography>
          {optional ? (
            <Chip
              label="Optional"
              size="small"
              sx={{
                height: 22,
                fontSize: "0.7rem",
                fontWeight: 600,
                bgcolor: alpha(theme.palette.info.main, 0.12),
                color: "info.main",
              }}
            />
          ) : null}
        </Box>
        {subtitle ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 0.5,
              lineHeight: 1.4,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {children}
    </Box>
  );
};

export default ComposerStepCard;
